"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalAuthorityEnvelope = isLocalAuthorityEnvelope;
exports.verifyLocalAuthorityEnvelope = verifyLocalAuthorityEnvelope;
const canonical_json_1 = require("./canonical-json");
function isLocalAuthorityEnvelope(value) {
    if (value === null || typeof value !== 'object' || Array.isArray(value)) {
        return false;
    }
    const envelope = value;
    const payload = envelope.payload;
    return (envelope.version === 1 &&
        envelope.alg === 'ES256' &&
        typeof envelope.kid === 'string' &&
        (envelope.purpose === undefined || typeof envelope.purpose === 'string') &&
        typeof envelope.signature === 'string' &&
        payload !== null &&
        typeof payload === 'object' &&
        !Array.isArray(payload) &&
        typeof payload.issuedAt === 'string' &&
        typeof payload.expiresAt === 'string');
}
/** Checks shape, key id, purpose, signature and expiry of an envelope. */
async function verifyLocalAuthorityEnvelope(envelope, options) {
    if (!isLocalAuthorityEnvelope(envelope)) {
        return { status: 'invalid', payload: null };
    }
    const { publicKeySpki, expectedKid } = options;
    if (!expectedKid || !publicKeySpki || !globalThis.crypto?.subtle) {
        return { status: 'missing-key', payload: null };
    }
    if (envelope.kid !== expectedKid) {
        return { status: 'invalid', payload: null };
    }
    if (options.expectedPurpose && envelope.purpose !== options.expectedPurpose) {
        return { status: 'invalid', payload: null };
    }
    let validSignature = false;
    try {
        const cryptoKey = await globalThis.crypto.subtle.importKey('spki', base64ToBytes(publicKeySpki), { name: 'ECDSA', namedCurve: 'P-256' }, false, ['verify']);
        validSignature = await globalThis.crypto.subtle.verify({ name: 'ECDSA', hash: 'SHA-256' }, cryptoKey, base64ToBytes(envelope.signature), new TextEncoder().encode((0, canonical_json_1.canonicalStringify)(envelope.payload)));
    }
    catch {
        return { status: 'invalid', payload: null };
    }
    if (!validSignature) {
        return { status: 'invalid', payload: null };
    }
    if (Date.parse(envelope.payload.expiresAt) <= options.now.getTime()) {
        // Signature is authentic; callers may use the payload to explain the
        // expiry but must not treat it as an active grant.
        return { status: 'expired', payload: envelope.payload };
    }
    return { status: 'valid', payload: envelope.payload };
}
/** Standard or URL-safe base64, with or without padding. */
function base64ToBytes(value) {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = `${normalized}${'='.repeat((4 - (normalized.length % 4)) % 4)}`;
    const binary = atob(padded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}
